import React, { useState, useEffect } from 'react';
import { THEME } from '../../utils/theme';
import api from '../../utils/api';
import Spinner from '../ui/Spinner';

const RateUnratedModal = ({ onClose, onUpdate, currentUser }) => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [rating, setRating] = useState(null);
  const [saving, setSaving] = useState(false);
  const myColor = currentUser?.theme_color || THEME.success;

  useEffect(() => {
    api.get('/api/games/unrated').then(data => {
      setGames(data.games || []);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const currentGame = games[currentIndex];

  const handleRate = async () => {
    if (rating === null || !currentGame) return;
    setSaving(true);
    try {
      await api.put(`/api/games/${currentGame.id}/rating`, { rating });
      setRating(null);
      if (currentIndex < games.length - 1) {
        setCurrentIndex(currentIndex + 1);
      } else {
        onUpdate();
        onClose();
      }
    } catch (err) {
      alert('Failed to save rating');
    }
    setSaving(false);
  };

  const handleSkip = () => {
    setRating(null);
    if (currentIndex < games.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      onClose();
    }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(5,5,10,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, backdropFilter: 'blur(20px) saturate(180%)', WebkitBackdropFilter: 'blur(20px) saturate(180%)' }} onClick={onClose}>
      <div style={{ background: `linear-gradient(145deg, ${THEME.bgElevated}, ${THEME.bgCard})`, borderRadius: '20px', padding: '24px', width: '95%', maxWidth: '400px', border: `1px solid ${THEME.border}`, boxShadow: `0 25px 80px ${THEME.shadowHeavy}`, animation: 'scaleIn 0.2s ease' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0, color: THEME.text, fontSize: '18px', fontWeight: '700' }}>Rate Your Games</h2>
          <button onClick={onClose} style={{ background: THEME.bgHover, border: 'none', borderRadius: '8px', padding: '8px 12px', color: THEME.textMuted, cursor: 'pointer' }}>✕</button>
        </div>

        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><Spinner /></div>
        ) : games.length === 0 ? (
          <div style={{ textAlign: 'center', color: THEME.textMuted, padding: '40px' }}>All played games have been rated! 🎉</div>
        ) : currentGame ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ color: THEME.textMuted, fontSize: '12px', marginBottom: '16px' }}>{currentIndex + 1} of {games.length}</div>
            <img src={currentGame.header_image} alt="" style={{ width: '100%', height: '140px', objectFit: 'cover', borderRadius: '12px', marginBottom: '16px' }} />
            <h3 style={{ color: THEME.text, margin: '0 0 8px', fontSize: '16px', fontWeight: '700' }}>{currentGame.name}</h3>
            <div style={{ color: THEME.textMuted, fontSize: '12px', marginBottom: '20px' }}>
              {Math.round(((currentGame.user_data?.[currentUser?.username]?.playtime) ?? ((currentUser?.username === 'omega' ? currentGame.playtime_omega : currentGame.playtime_supe) || 0)) / 60)}h played
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginBottom: '20px', flexWrap: 'wrap' }}>
              {[1,2,3,4,5,6,7,8,9,10].map(n => (
                <button key={n} onClick={() => setRating(n)} style={{ width: '36px', height: '36px', borderRadius: '8px', border: rating === n ? `2px solid ${myColor}` : `1px solid ${THEME.border}`, background: rating === n ? `${myColor}30` : THEME.bg, color: rating === n ? myColor : THEME.textMuted, fontWeight: '600', fontSize: '14px', cursor: 'pointer' }}>{n}</button>
              ))}
            </div>

            <div style={{ display: 'flex', gap: '12px' }}>
              <button onClick={handleSkip} style={{ flex: 1, background: THEME.bgHover, border: 'none', borderRadius: '10px', padding: '12px', color: THEME.textMuted, fontWeight: '600', cursor: 'pointer' }}>Skip</button>
              <button onClick={handleRate} disabled={rating === null || saving} style={{ flex: 1, background: rating !== null ? myColor : THEME.bgHover, border: 'none', borderRadius: '10px', padding: '12px', color: rating !== null ? '#000' : THEME.textMuted, fontWeight: '600', cursor: rating !== null ? 'pointer' : 'not-allowed', opacity: rating === null ? 0.5 : 1 }}>{saving ? 'Saving...' : 'Rate'}</button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default RateUnratedModal;
